import { render, staticRenderFns } from "./_delete_record_form.vue?vue&type=template&id=214e701d&"
import script from "./_delete_record_form.vue?vue&type=script&lang=js&"
export * from "./_delete_record_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports